// Dependencies
import { FC } from "react";
import { useSnackbar } from "notistack";
import { useMutation, useQueryClient } from "react-query";

// Components
import { WalletForm } from "~/components/Layout/LayoutForm";

// Types
import { QUERY_KEY } from "~/enums";
import { TWalletAddData, TWalletType, TQueryError } from "~/types/types";

// api
import { addWallet } from "~/services/wallet";

// Styles
import { StyledAddLabel } from "~/components/Layout/LayoutAdd";
import { StyledInfoWrapper } from "~/components/Layout/LayoutInfo/LayoutInfo.styled";

interface WalletAddProps {
  type: keyof TWalletType;
  onCancel: Function;
}

const WalletAdd: FC<WalletAddProps> = ({ type, onCancel }) => {
  const { enqueueSnackbar } = useSnackbar();

  const queryClient = useQueryClient();
  const addWalletMutation = useMutation({
    mutationFn: addWallet,
    onSuccess() {
      enqueueSnackbar("Add Wallet success!", { variant: "success" });
      queryClient.invalidateQueries(QUERY_KEY.WALLET.WALLET_LIST);
      onCancel();
    },
    onError(error: TQueryError) {
      enqueueSnackbar(error.message, { variant: "error" });
    },
  });
  const handleAddWallet = (data: TWalletAddData) => {
    addWalletMutation.mutate(data);
  };
  return (
    <StyledInfoWrapper>
      <StyledAddLabel key={1}>Add Wallet</StyledAddLabel>
      <WalletForm
        key={2}
        onSubmit={handleAddWallet}
        type={type}
        onCancel={onCancel}
      />
    </StyledInfoWrapper>
  );
};

export default WalletAdd;
